import type {TStore} from "modules/types/store";

export const getSettings = (store: TStore) => store.settings.settings;
export const getIsWinnerState = (store: TStore) => Boolean(store.settings.settings?.winner);
